export default __webpack_public_path__ + "static/LINK-e6e8d688b54af33e1f99f890a0308c2b.png";